module.exports = __webpack_public_path__ + "static/media/basket-grey.43c74108.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/basket-grey.svg
// module id = 252
// module chunks = 0